































import { Component, Vue } from 'vue-property-decorator'

@Component({
  head: {
    meta: [{ name: 'robots', content: 'noindex, nofollow' }],
  },
})
export default class PublicReviewLayout extends Vue {}
